<template>
  <div>
    <div class="dashboard-container">
      <page-searcher :searchMethod="() => loadData(true)" :searchModel="searchModel" v-if="showSearch">
        <template slot="search-items">
          <slot name="search-items"></slot>
        </template>
      </page-searcher>
    </div>
    <div class="dashboard-container">
      <div class="page-card">
        <div class="page-card-header">
          <slot name="table-title">
            <span>{{ $route.meta.title }}</span>
          </slot>
          <div class="card-operation">
            <slot name="page-actions"></slot>

            <el-icon></el-icon>
            <el-tooltip class="item" content="刷新" effect="dark" placement="top">
              <el-button @click="loadData" icon="el-icon-refresh"
                         class="refresh-opt"
                         type="text"></el-button>
            </el-tooltip>
          </div>
        </div>
        <div class="page-card-body">
          <el-table
            :data="listData"
            @sort-change="handleSortChange"
            v-loading="listLoading"
            :summary-method="getSummaries"
            :show-summary="showSummary"
            border
            @selection-change="handleSelectionChange"
            highlight-current-row
            @current-change="handleTableCurrentChange"
            ref="table"
            style="width: 100%"
            tooltip-effect="dark">
            <el-table-column type="selection" width="55" align="center" v-if="showSelection"></el-table-column>
            <el-table-column v-for="(field, index) in fields" :key="index" :label="field.label" :prop="field.key"
                             :width="field.width || ''"
                             :fixed="field.fixed ? field.fixed : false"
                             :sortable="field.sortable ? field.sortable : false"
                             :align="field.align ? field.align : (field.width && field.width < 130 ? 'center' : 'left')">
              <template slot-scope="scope">
                <column-content :row="scope.row" :field="field"></column-content>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="itemActions.length > 0"
                             :width="Math.min(itemActions.length * 130, 170)"
                             align="center"
                             fixed="right">
              <template slot-scope="scope">
                <column-actions :row="scope.row" :actions="itemActions"
                                @aclick="(action, row) => callAction(action, row)"></column-actions>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="showPaginate"
            class="page-card-pagination"
            :current-page="page.current"
            :page-size="page.size"
            :page-sizes="[10, 20, 30, 50, 100]"
            :total="page.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageSearcher from "@/components/PageSearcher"
import {getTableSummaries} from "@/function/element.helper"
import {Dropdown, DropdownMenu, DropdownItem} from 'element-ui'
import checkPermission from "@/utils/checkPermission"

export default {
  name: "PageTable",
  props: {
    showSearch: {
      type: Boolean,
      default() {
        return true
      }
    },
    searchModel: {
      type: Object,
      default() {
        return {}
      }
    },
    showPaginate: {
      type: Boolean,
      default() {
        return false
      }
    },
    getData: {
      type: Function,
      required: true,
    },
    getDataParams: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      required: true
    },
    itemActions: {
      type: Array,
      default() {
        return []
      }
    },
    showSummary: {
      type: Boolean,
      default() {
        return false
      }
    },
    showSummaryColumns: {
      type: Array,
      default() {
        return []
      }
    },
    showSelection: {
      type: Boolean,
      default() {
        return false
      }
    },
    autoLoad: {
      type: Boolean,
      default() {
        return true
      }
    },
  },
  data() {
    return {
      searchItemCount: 0,
      showMoreSearch: false,
      listLoading: false,
      listData: [],
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      order_by_column: 'id',
      order_by_direction: 'desc',
      selection: [],
      loadDataLock: false,
      currentRow: null,
    }
  },
  components: {
    PageSearcher,
    ColumnContent: {
      props: {
        row: {
          required: true
        },
        field: {
          required: true
        }
      },
      render(h) {
        if (this.field.render) {
          return this.field.render(this.row, h)
        }
        if (this.field.key) {
          return h('div', {
            attrs: {
              class: this.field.space ? this.field.space : 'nowrap'
            }
          }, this.row[this.field.key])
        }
      }
    },
    ColumnActions: {
      props: {
        row: {
          required: true
        },
        actions: {
          required: true
        },
      },
      render(h) {
        let onClick = (action, row) => {
          this.$emit('aclick', action, row)
        }
        let showActions = this.actions.filter((action) => {
          if (action.permission !== undefined && !checkPermission(action.permission)) return false
          return (!action.showAction || action.showAction(this.row))
        })
        let actions = []
        let show_more = showActions.length > 2
        let show_index = Math.min(1, showActions.length - 1)
        if (show_more) show_index -= 1
        for (let cur_index = 0; cur_index <= show_index; cur_index++) {
          actions.push(h('div', {
            attrs: {
              class: 'table-action-item ' + showActions[cur_index].type
            },
            on: {
              click: () => {
                onClick(showActions[cur_index].action, this.row)
              }
            }
          }, showActions[cur_index].label))
        }
        if (show_more) {
          let dropdownActions = []
          for (let more_index = show_index + 1; more_index <= showActions.length - 1; more_index++) {
            dropdownActions.push(h(DropdownItem, {
              props: {
                command: showActions[more_index].action
              },
            }, showActions[more_index].label))
          }
          let dropdownInstance = h(Dropdown, {
            attrs: {
              class: 'el-dropdown table-action-item'
            },
            props: {
              trigger: 'click'
            },
            on: {
              command: (action) => {
                onClick(action, this.row)
                dropdownInstance.componentInstance.hide()
              }
            }
          }, [<span class="el-dropdown-link"> 更多<i
            class="el-icon-arrow-down el-icon--right"></i></span>, h(DropdownMenu, {}, dropdownActions)])
          actions.push(dropdownInstance)
        }
        return h('div', {
          attrs: {
            class: 'table-actions'
          }
        }, actions)
      }
    },

  },
  created() {

  },
  mounted() {
    if (this.autoLoad) {
      this.loadData()
    }
  },
  methods: {
    getParams() {
      let that = this
      let query = {
        order_by_column: that.order_by_column,
        order_by_direction: that.order_by_direction,
      }
      if (that.showPaginate) {
        query.page = that.page.current
        query.page_size = that.page.size
      }
      Object.assign(query, that.searchModel)
      return query
    },
    loadData(reset_page = false) {
      let that = this
      if (reset_page) {
        that.page.current = 1
      }
      if (that.loadDataLock) return false
      that.loadDataLock = true
      let query = {
        order_by_column: that.order_by_column,
        order_by_direction: that.order_by_direction,
      }
      if (that.showPaginate) {
        query.page = that.page.current
        query.page_size = that.page.size
      }
      Object.assign(query, that.searchModel)
      that.listLoading = true
      that.getData(...that.getDataParams, query).then(res => {
        if (that.showPaginate) {
          that.page.total = res.total
          that.page.current = res.current_page
          that.listData = res.data
        } else {
          that.listData = res
        }
        that.listLoading = false
        that.loadDataLock = false
      }).catch(() => {
        that.listLoading = false
        that.loadDataLock = false
      })
    },
    handleSortChange(column) {
      this.order_by_column = column.prop
      this.order_by_direction = column.order == 'ascending' ? 'asc' : 'desc'
      if (column.column && column.column.sortable) {
        this.loadData()
      }
    },
    handleSelectionChange(val) {
      this.selection = val
    },
    getSelection() {
      return this.selection
    },
    handleTableCurrentChange(val) {
      this.currentRow = val
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.loadData()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.loadData()
    },
    callAction(action, item) {
      this.$emit('onActionClick', action, item)
    },
    getSummaries({columns, data}) {
      return getTableSummaries(this.showSummaryColumns, columns, data)
    },
  },
}
</script>

<style scoped>

</style>
